import CardList from "../components/CardList";

function Home() {
  return (
    <>
      <CardList />
    </>
  );
}

export default Home;
